<p><b>2024-11-12 12.30</b></p>
<p>#15691 - Bugfix rapport Närvaro på institutionsnivå per månad.</p>

<p><b>2024-08-12 14:40</b></p>
<p>#15600 - Rensa maillistan mellan sökningar i rapport Medlemmar.</p>

<p><b>2024-05-02 14:30</b></p>
<p>Rapport Gottstående2. Lagt till "Icke medlemskap i".</p>

<p><b>2024-04-30 11:00</b></p>
<p>#15514 - Rapport Gottstående2. Buggfix medlemsår blir null om man inte väljer ett år i listan.</p>

<p><b>2024-04-29 12:00</b></p>
<p>#15513 - Fixat till rapport Gottstående 2.</p>

<p><b>2024-04-26 16:30</b></p>
<p>#15436 - Buggfix i rapport Närvaro på institutionsnivå per månad. Valt år triggas inte förrän man lämnar fältet.</p>

<p><b>2024-04-26 11:30</b></p>
<p>#15510 - Gjort om Rapport Gottstående 1.</p>

<p><b>2024-04-12 16:00</b></p>
<p>#15502 - Videoklippen (hjälp) har gjorts om så att de inte längre körs i Azure Media Services som kommer läggas ner.</p>

<p><b>2024-04-12 16:00</b></p>
<p>#15503 - Rapport Uppdrag/Ämbeten - tillägg av Icke Medlemskap i.</p>

<p><b>2024-04-03 12:40</b></p>
<p>#15498 - Ändrat label för Emejl till Epost för medlemsmatrikel A6 (word och pdf).</p>

<p><b>2024-03-01 18:58</b></p>
<p>#15449 - Rättning av fel när rapport Gottstående2 skapas.</p>

<p><b>2024-02-21 13:00</b></p>
<p>#15435 - Rättning av fel när matrikel skapas.</p>

<p><b>2024-01-08 11:55</b></p>
<p>#15324 - Rättning av felaktigheter i hanteringen av epostutskick från olika miljöer (Utveckling, Test och Produktion).</p>

<p><b>2024-01-05 11:00</b></p>
<p>#15321 - Inaktivering av knappen Registrera inbetalning när användaren klickat på den för att undvika dubbelregistrering samt 500-fel.</p>

<p><b>2023-11-10 09:20</b></p>
<p>#15258 - Justeringar i Medlemsmatrikel A6 enligt önskemål.</p>

<p><b>2023-10-12 15:00</b></p>
<p>#15243 - Fel i rapport utmärkelser rättat, medlemmar kom felaktigt med trots att de inte är kvar i läger.</p>

<p><b>2023-09-20 08:30</b></p>
<p>#15218 - Fel ordning på kolumner för fadder id och fadder namn i Rapport Medlemmar (csv).</p>

<p><b>2023-08-25 16:00</b></p>
<p>Några små justeringar i Medlemsmatrikel A6. Tagit bort Grader, möblerat om lite.</p>

<p><b>2023-08-20 18:05</b></p>
<p>Lagt till möjlighet att kopiera mailadresser. Förändringar av hur posterna skrivs ut i etiketter för Medlemmar och Institutioner samt minskat textstorleken något. För institutionsetiketterna tas raden för C/O-adressen bort om det saknas.</p>

<p><b>2023-06-30 16:10</b></p>
<p>Förändringar i Medlemsmatrikel A6.</p>

<p><b>2023-06-30 07:55</b></p>
<p>Förändringar i Medlemsmatrikel A6.</p>

<p><b>2023-06-18 13:20</b></p>
<p>Gjort det möjligt att söka och markera samtliga institutioner för en specifik institutionstyp.</p>

<p><b>2023-06-07 11:00</b></p>
<p>Fixat datum i uppdrag.</p>

<p><b>2023-05-11 14:45</b></p>
<p>Skapat etikettrapporter m m från rapport Institutioner och rapport Medlemmar.</p>

<p><b>2023-01-31 17:00</b></p>
<p>Fixat bug med medlemsavgifter.</p>

<p><b>2023-01-09 15:00</b></p>
<p>Optimerat kod för medlemsavgifter.</p>

<p><b>2022-12-30 17:00</b></p>
<p>#14880: fel nedsättning</p>

<p><b>2022-12-30 12:00</b></p>
<p>Uppdaterat manual för ÄM.</p>

<p><b>2022-12-29 01:15</b></p>
<p>Räknat om alla medlemsavgifter.</p>
<p>Fixat bugg med medlemsavgifter.</p>

<p><b>2022-12-14 09:15</b></p>
<p>Fick inte upp alla medlemmar i drop-down i när man skulle sätta ned avgift.</p>

<p><b>2022-12-08 08:15</b></p>
<p>#14852: Medlemmar som tidigare gått ur logen kommer inte upp när man söker efter dem i "koppla till storloge"</p>

<p><b>2022-12-06 08:15</b></p>
<p>Buggfix i rapport: närvaro per månad.</p>

<p><b>2022-11-29 07:15</b></p>
<p>Omskrivning av uträkningen av medlemsavfigter.</p>
<p>Kan verka långsam eftersom den inte är optimerad än. Ska testas så allt blir rätt innan optimering av algoritmen görs.</p>

<p><b>2022-10-11 07:50</b></p>
<p>Ytterligare buggfix när man ska skicka mail från vyn Sök medlem.</p>

<p><b>2022-10-10 21:30</b></p>
<p>Buggfix när man ska skicka mail från vyn Sök medlem.</p>

<p><b>2022-10-10 17:30</b></p>
<p>#14778: FS och PF ska kunna radera inlagda rader i Nedsättningsvyn.</p>

<p><b>2022-10-06 18:00</b></p>
<p>#14771: Fel medlamsavgifter när årsavgift ändras</p>

<p><b>2022-10-04 09:00</b></p>
<p>#14752: Fixat knappar och etiketter i Rapport: Utmärkelser</p>

<p><b>2022-09-26 08:00</b></p>
<p>#-: Lagt till C/O i adressetiketter för institutionsrapport.</p>
<p>#-: Fixat till C/O i matrikel för institutionsrapport.</p>

<p><b>2022-09-22 16:00</b></p>
<p>#14719: Fixat bugg med medlemsavgifter.</p>
<p>#-: Fixat adressetiketter i Rapporter/Institutioner.>

<p><b>2022-09-18 16:00</b></p>
<p>#-: Lagt till möjligheten att exportera word i både A4 och A6-format i medlemsmatrikeln.</p>

<p><b>2022-09-17 16:00</b></p>
<p>#-: Rensat upp medlemskapssidan.</p>

<p><b>2022-09-16 16:00</b></p>
<p>#-: Epost från rapport utmärkelser.</p>

<p><b>2022-09-05 08:00</b></p>
<p>#14719: Fixat bugg med medlemsavgifter.</p>
<p>#14716: Fixat bugg med medlemsavgifter för nyinvigna.</p>

<p><b>2022-08-18 09:00</b></p>
<p>#14699: Fixat bugg med datumformat i medlemsmatrikel.</p>

<p><b>2022-08-17 09:00</b></p>
<p>#14696: Fixat bugg i medlemsavgifter.</p>

<p><b>2022-06-30 17:00</b></p>
<p>#14677: Tagit bort blanksteg i mejlfält</p>
<p>#14650: Trim-funktion på e-postadresserna</p>

<p><b>2022-06-29 17:00</b></p>
<p>#14646: Fixat bugg vid avslut av avgångsbrev</p>
<p>#14677: Tagit bort blanksteg i mejlfält</p>
<p>#14666: Fixat bugg med Lägermedlemskap när AVGBREV i loge avslutas</p>

<p><b>2022-06-22 17:00</b></p>
<p>#14671/#14676: Fixat bugg för fel datumformat i matrikel pdf</p>
<p>#14675: Fixat buff för fel gästantal vid översikten</p>
<p>#14688: Fixat felaktigt datum i matrikel</p>

<p><b>2022-06-19 17:00</b></p>
<p>#14579: Fixat bugg för medlemsavgift</p>
<p>#14571: Fixat bugg för ny medlem i loge eller läger</p>
<p>#14500/#14659/#14683: Fixat buggar för medlemsavgifter</p>

<p><b>2022-06-14 17:00</b></p>
<p>#14615: Bokstavsordning Matrikel</p>
<p>#14574: Fixat bugg vid avslut av medlemskap</p>
<p>#14570: Fixat bugg i rapport Uppdrag/ämbeten</p>

<p><b>2022-04-25 17:00</b></p>
<p>#14493: Fixat bugg där medlem kommer inte upp i listan över medlemmar under Lägg till närvaro</p>
<p>#14369: Ändrat hur videoklipp visas upp</p>

<p><b>2022-04-01 17:00</b></p>
<p>#14495: Fixat bugg för att registrera medlemmar i EL</p>
<p>#14499: Fixat bugg där epost kommer från fel adress</p>
<p>#14437: Fixat bugg i institutioner per distrikt rapport</p>
<p>#14438: Fixat bugg i analys medlemsflöde rapport</p>
<p>#14502: Fixat bugg när man registrerar närvaro</p>
<p>#14426: Fixat bugg där knappar för excel försvinner</p>

<p><b>2022-03-30 17:00</b></p>
<p>#14482: Fixat felmeddelande när de försöker byta primärinstitution</p>
<p>#14492: Fixat bugg med att radera medlemsskap</p>

<p><b>2022-03-29 17:00</b></p>
<p>Nya index i Databasen för prestanda.</p>
<p>Lagt till möjligheten för admin att räkna om medlemsavgifter manuellt.</p>
<p>Fixat bug som gjorde att vissa medlemmar hade för många år i sina medlemsavgifter.</p>
<p>Fixat bug i rapport: Utmärkelser.</p>

<p><b>2022-03-17 17:00</b></p>
<p>Borttag av null-värden i csv-exporter.</p>

<p><b>2022-03-15 17:00</b></p>
<p>Gjort det möjlig att registrera medlemmar från utlandet (EL).</p>

<p><b>2022-03-08 23:00</b></p>
<p>Fixat bugg med avsändare i Från-fältet när man skickar epost.</p>

<p><b>2022-03-04 23:00</b></p>
<p>Från-fältet i email tar nu hänsyn till om du har ett Uppdrag med epost i Storlogen.</p>
<p>Rapport Institutioner: Buggfix. Excel-knappen ska ligga kvar när man kryssar i checkboxar.</p>
<p>Rapporter: Buggfix. Om olika telefonnummer enbart innehåller siffror tolkar Excel det som sifferfält vilket gör att nollan i början försvinner. Fixat i csv-exporter som har telefonnummer.</p>

<p><b>2022-02-28 15:10</b></p>
<p>Admin: Kanslist ska kunna radera dubbletter.</p>

<p><b>2022-02-28 15:10</b></p>
<p>Buggfix: Buggfix - SOFT-Rapport.</p>
<p>Buggfix: Buggfix - Rapport Utmärkelser tar nu hänsyn till om man väljer Teckentyp eller icke Teckentyp.</p>

<p><b>2022-02-24 13:10</b></p>
<p>Buggfix: Buggfix - Lägg till Uppdrag och Utmärkelse som Registeransvarig.</p>

<p><b>2022-02-22 18:10</b></p>
<p>Hjälp videoklipp: Gjort förändringar rörande videoklippen (hjälp). Dessa öppnas nu i en egen flik och startar dessutom automatiskt.</p>

<p><b>2022-02-22 14:10</b></p>
<p>Byta fadder: Buggfix för att Spara-knappen ska aktiveras när man valt fadder. </p>

<p><b>2022-02-22 14:10</b></p>
<p>Medlemskap: Gjort ikoner för att ändra, ta bort och avsluta medlemskap tydligare. </p>

<p><b>2022-02-22 14:10</b></p>
<p>Lägg till Uppdrag: Gjort ändringar för att det ska fungera bättre. Bland annat ska tillägg av Uppdrag slå igenom direkt på MinSida utan att behöva ladda om vyn.</p>

<p><b>2022-02-22 14:10</b></p>
<p>Lägg till Utmärkelse: Gjort ändringar för att det ska fungera bättre. Bland annat ska tillägg av Utmärkelse slå igenom direkt på MinSida utan att behöva ladda om vyn.</p>

<p><b>2022-02-03 20:45</b></p>
<p>Registrera medlemsavgift: Buggfix - epostadresslistan ska tömmas när man lämnar epost-vyn.</p>

<p><b>2022-02-02 15:30</b></p>
<p>Fixat så man som kanslist/Sysadmin kan göra undantag och lägga till Grader/Tecken som kräver andra grader.</p>

<p><b>2022-01-31 18:30</b></p>
<p>Rapport Uppdrag: Lagt till nya fält enligt spec.</p>
<p>Rapport Medlemmar: Lagt till nya fält enligt spec.</p>

<p><b>2022-01-28 11:00</b></p>
<p>Rapport Utmärkelser: Lagt in en begränsning på antal poster som hämtas vid sökning. Förnärvarande är det satt till 2000 poster men kan lätt justeras.</p>
<p>Admin: Radera medlem. Lagt till funktionalitet för att radera medlem i admin-gränssnittet.</p>

<p><b>2022-01-26 10:30</b></p>
<p>Optimering av Institutionsrapport.</p>

<p><b>2022-01-26 08:45</b></p>
<p>Lilla Matrikeln: Lagt till Swish.</p>

<p><b>2022-01-25 18:30</b></p>
<p>Rapport Institutioner: Lagt till fältet Bankgiro i csv-exporten.</p>
<p>Registrera Medlemsavgifter: Korrigerat filnamnet på exporterad csv-fil enligt önskemål.</p>
<p>Rapport Institutioner: Buggfix för att kunna lista samtliga institutioner på sidan utan att välja institutionstyp.</p>
<p>Medlemsmatrikel: Justerat filnamnet för csv-export enligt önskemål.</p>
<p>Matrikelkort: Justerat filnamnet på pdf-export enligt önskemål.</p>

<p><b>2022-01-24 18:30</b></p>
<p>Institutioner: Medlemsmatrikel.</p>

<p><b>2022-01-23 17:30</b></p>
<p>Rapport Närvaro på medlemsnivå: Gjort listboxen för institutioner filtrerbar.</p>
<p>Institutionsvyn: PS och PF ska inte kunna redigera e-post.</p>

<p><b>2022-01-21 19:30</b></p>
<p>Rapport Utmärkelser: Fixat så att man får med mer data i rapporten som saknats.</p>
<p>Registrera medlemsavgifter: Lagt till Avgångsbrev samt Utträdesdatum i csv-export.</p>
<p>Rapport Analys Medlemsflöde: Buggfix så att antal medlemmar vid årets slut ska stämma med antal medlemmar vi nästa års början.</p>
<p>Faxnummer Medlem: Nollställt faxnummer för medlem om det står konstigheter (text).</p>

<p><b>2022-01-20 19:30</b></p>
<p>Institutioner: Bytt ut faxnummer mot swishnummer i vyer och rapporter samt databas.</p>
<p>Rapport Institutioner: Bytt ut institutionstypid till institutionstyp i klartext.</p>
<p>Rapport Utmärkelser: Lagt till en massa nya kolumner enligt spec. Saknas några fält som ska läggas till i backend.</p>
<p>Admin Radera medlem: Förberett vy i klienten för att göra det möjligt för sysadmin att radera medlem om det av misstag blivit dubletter.</p>

<p><b>2022-01-19 19:30</b></p>
<p>Matrikel: Vid uttag av matrikel(pdf) så stannar man nu kvar på MinSida för den medlem man tar ut matrikel för.</p>
<p>Rapport Institutioner: Lagt till fler fält i csv-exporten samt möblerat om ordningen på fälten.</p>
<p>Rapport Institutioner: Gjort det möjligt att söka fram samtliga institutioner på en gång utan att välja institutionstyp.</p>
<p>Sök Institutioner: Gjort det möjligt att söka fram samtliga institutioner på en gång utan att välja institutionstyp.</p>
<p>Samtliga rapporter: Satt enhetliga namn på rapporterna (namn_YYMMDD)</p>

<p><b>2022-01-17 23:30</b></p>
<p>Buggfix utmärkelserapport: Fel invigningsdatum.</p>
<p>Buggfix medlemsskap: Justering av startdatum av aktiv primärloge.</p>
<p>Mail: Mindre font, kursivt och adderat namn i mailfotnoten. </p>

<p><b>2022-01-17 14:05</b></p>
<p>Admin: Lagt till funktionalitet för att kunna uppdatera välkomsttexten på första sidan via admingränssnittet.</p>
<p>Första sidan: Lagt till funktionalitet för att läsa upp korrekt välkomsttext.</p>

<p><b>2022-01-14 09:45</b></p>
<p>[Admin GDPR: Avidentifiera medlem enligt GDPR. Funktionalitet på plats.]</p>
<p>Buggfix Registrera medlemsavgifter: Buggfixar - Export till Excel. Bland annat när man tryckte på Excel-knappen flera gånger efter varandra.</p>
<p>Buggfix Registrera medlemsavgifter: Buggfixar - Export till Excel. Vid filtrering av datat blev Excel-exporten felaktig.</p>

<p><b>2021-12-21 16:25</b></p>
<p>Buggfix MinSida: Spara-knappen ska bli aktiverad.</p>

<p><b>2021-12-20 10:15</b></p>
<p>Buggfix Registrera inbetalning: Checkboxhantering rättad på nytt.</p>

<p><b>2021-12-20 09:55</b></p>
<p>Buggfix Registrera inbetalning: Checkbox hanterade klick på fel sätt. Är åtgärdat. </p>

<p><b>2021-12-16 19:45</b></p>
<p>Buggfix MinSida: Ämbetsmän ska inte kunna editera sin grundinformation på MinSida.</p>

<p><b>2021-12-16 08:45</b></p>
<p>Hjälp: Bytt namn på Lathund för PS och FS samt sett till så att filen har något innehåll.</p>

<p><b>2021-12-15 22:15</b></p>
<p>Hjälp: Lagt till Lathund för PS och FS.</p>
<p>Registrera ny medlem: Gjort det möjligt att registrera personer med födelsedatum från och med 1700-01-01.</p>
<p>Loggutskrift: Raderat en loggutskrift som kom med i en av rapporterna.</p>

<p><b>2021-12-14 19:20</b></p>
<p>Lagt till ett generiskt sätt att hämta info om medlemmar för CSV-rapporter.</p>
<p>Fixat sortering från databasen när man söker medlemmar.</p>
<p>Registrera inbetalningar: Lagt till önskade kolumner för csv-export (excel).</p>

<p><b>2021-12-13 17:10</b></p>
<p>MinSida: Möjliggjort inmatning av födelsedatum från och med 1700-01-01 på befintliga medlemmar.</p>
<p>Rapport - Närvaro på institutionsnivå per år: Buggfix - felmeddelande när man inte valt år i vissa lägen.</p>
<p>Rapport - Uppdrag: Lagt till saknad ikon för epost.</p>

<p><b>2021-12-08 18:10</b></p>
<p>Koppla medlemmar till F1: Fix för att kunna koppla medlemmar till F1 - utvalda vänner.</p>

<p><b>2021-12-08 15:55</b></p>
<p>Medlemskap: Justeringar för att sysadmin och kanslist ska kunna uppdatera och ta bort medlemskap när det blivit felregistrerat.</p>
<p>Medlemskap: Bugfixar vad gäller datum.</p>
<p>Medlemskap: Tagit bort UT1, AV1, AVGBREV1, SOFT, SOFT1 institutionerna i vyn Byt primärinstitution.</p>
<p>MinSida: Möjliggjort radering av fadder som är kopplad till medlem.</p>
<p>Registrera ny medlem: Lagt in en ändring som förhoppningsvis ska göra så att inte personer som registreras in efter varandra får samma arbetsadress.</p>

<p><b>2021-12-07 14:05</b></p>
<p>Radera medlemskap: Lagt till funktionalitet för att sysadmin och kanslist ska kunna radera medlemskap.</p>

<p><b>2021-12-06 12:00</b></p>
<p>Ändra slutdatum medlemskap: Fixat så att sysadmin och kanslist kan sätta slutdatum till 9999-12-31 för medlemskap.</p>

<p><b>2021-12-06 09:00</b></p>
<p>Avsluta medlemskap: Fixat så att det blir rätt datum när man avslutar medlemskap och fyller i datumet manuellt.</p>

<p><b>2021-12-05 12:45</b></p>
<p>Lägg till uppdrag och utmärkelser.</p>

<p><b>2021-12-02 10:05</b></p>
<p>Fixat bugg vid nedsättning av avgifter för år störra än 2021.</p>

<p><b>2021-11-29 21:05</b></p>
<p>Lägg till Uppdrag: Lagt till funktionalitet så att sysadmin och kanslist kan addera uppdrag till vilken medlem som helst i vilken institution som helst.</p>
<p>Lägg till Utmärkelse: Lagt till funktionalitet så att sysadmin och kanslist kan addera utmärkelser till vilken medlem som helst i vilken institution som helst.</p>
<p>Rapport Uppdrag: Fixat Välj alla för att markera medlemmar i resultatet.</p>

<p><b>2021-11-24 18:15</b></p>
<p>Admin: Flyttat menyvalet för att Hantera kontolösa till Stödtabeller.</p>
<p>Datum: Utökat kalendern så att det går att välja år från 1720.</p>

<p><b>2021-11-24 15:15</b></p>
<p>Admin: Skapat nytt menyval under Systemadministration (Hantera kontolösa) för att skapa konton för medlemmar som saknar detta sedan tidigare.</p>

<p><b>2021-11-24 07:45</b></p>
<p>Skapa ny medlem: Lagt in en spärr så att det inte går att trycka på Spara-knappen flera gånger.</p>

<p><b>2021-11-23 20:15</b></p>
<p>Skapa ny medlem: Lagt till kontroll för invigningsdatum - måste vara mindre än aktuellt datum.</p>
<p>Skapa ny medlem: Gjort en justering för att förhindra dubbelregistrering av nya medlemmar.</p>


<p><b>2021-11-23 09:15</b></p>
<p>Möten rubrik: Lagt in begränsning på 30 tecken för mötesrubrik så att det matchar databasen.</p>
<p>Mötesdetaljer: Lagt till funktionalitet för att kunna sortera på primärinstitution när man ska lägga till deltagare.</p>

<p><b>2021-11-20 17:15</b></p>
<p>MinSida: Lagt till faxnummer.</p>

<p><b>2021-11-19 19:05</b></p>
<p>Mailvy: Fixat så att det bör bli lite mindre utrymme mellan textraderna i skickade mail.</p>

<p><b>2021-11-18 18:05</b></p>
<p>Registrera ny medlem: Gjort vissa förbättringar när man skapar ny medlem.</p>
<p>Registrera ny medlem: Fixat så att initieringsdatumet blir korrekt både via kalender och manuellt.</p>
<p>Redigera medlemskap: Fixat så att PS och PF inte ska kunna redigera till-datum om det är 9999-12-31.</p>

<p><b>2021-11-16 18:05</b></p>
<p>Registrera medlemsavgifter: Fixat så att inte alla epost-adresser blir rödmarkerade.</p>
<p>Rapport Uppdrag: Fixat så att checkboxarna dyker upp i resultatlistan. Har även justerat behörighetskontrollen för epost och etiketter.</p>
<p>Institutionsvyn: Koppla medlem till SGL.</p>
<p>Institutionsvyn: Koppla medlem till F1 - utvalda vänner.</p>
<p>Rapport Utmärkelser: Fixat så att gatuadress kommer med i csv-fil. Saknas postnummer från backend.</p>

<p><b>2021-11-10 10:00</b></p>
<p>Fixat Memberfees när man går med i ett läger.</p>
<p>Fixat så man endast får unika svar(inga dubbletter) när man söker efter medlemmar för att gå med i läger. </p>

<p><b>2021-11-09 10:00</b></p>
<p>Institutionsvy: Lägg till Uppdrag. Buggfix för att slippa felmeddelande.</p>
<p>Startsidan: Rödmarkerat text angående var man byter roll.</p>
<p>Koppla medlem till institution: Bytt plats på Sök- och Rensa-knapparna.</p>
<p>Fixat sök för att lägga till medlem till storloge.</p>
<p>Fixat Memberfees i nya institutionen när man byter primärloge.</p>

<p><b>2021-11-08 13:30</b></p>
<p>Fixat sökning av medlemmar när man lägger till medlemskap i EGL, SGL eller SL.</p>

<p><b>2021-11-03 12:30</b></p>
<p>Rapport Medlemmar: Buggfix. Finns personer som saknar primärloge i db. Fixat så att det hanteras. På dessa kommer det info om att medlemmen saknar primärloge i primärinst-kolumnen.</p>

<p><b>2021-11-02 13:20</b></p>
<p>Sök person: Buggfix när man trycker på rensa-knappen och gör ny sökning.</p>

<p><b>2021-11-02 10:00</b></p>
<p>Fixat så man kan editera insitution i utmärkelse på medlemssidan.</p>

<p><b>2021-11-01 17:55</b></p>
<p>Fixat och gjort om rapporten analys medlemsflöde. Fixat när distrikt är valt.</p>
<p>Registrera medlemsavgifter: Nya medlemmar ska komma upp i listan.</p>
<p>Närvaro möten: Fixat så att medlemmar som initierats samma dag som mötet hålls ska gå att addera som närvarande på mötet.</p>

<p><b>2021-10-30 15:45</b></p>
<p>Rapport Närvaro på institutionsnivå per år: Buggfix för att institutionsnummer ska stämma.</p>
<p>Admin Ändra välkomsttext: Förberett klient för att kunna skifta mellan text för mobil och för större skärm.</p>

<p><b>2021-10-29 11:00</b></p>
<p>Fixat så man kan lägga till framtida medlemsavgifter (Förberett i klienten - återstår en del på backend).</p>
<p>Institutionsvy: Buggfix - koppla medlem till läger och EGL1.</p>
<p>Registrera medlemsavgift: Uppdatera årslistan med de år som det finns årsavgifter inlagda för.</p>
<p>Lägg till utmärkelse: Buggfix - Justering av villkor för att kunna tilldelas ny utmärkelse.</p>
<p>MinSida - Ändra Uppdrag - Ändra Utmärkelse: Satt maxdatum till 2099-12-31 istället för 2030-12-31.</p>
<p>Rapport Utmärkelser: Buggfix. Fixat datum i csv-export (Skapad, Invigd datum, Födelsedatum).</p>
<p>Rapport Analys medlemsflöde: Buggfix. Kan kryssa i år när man valt distrikt.</p>
<p>MinSida Editera Utmärkelse: Har förberett i klienten så att man kan välja institution - återstår lite fix på backend.</p>

<p><b>2021-10-26 10:45</b></p>
<p>Mail: Buggfix i validering av mailadresser.</p>

<p><b>2021-10-24 18:00</b></p>
<p>Lilla matrikeln: Fixat datumformat.</p>
<p>MinSida: Fixat så att tidigaste födelseår är 1800 istället för 1920.</p>

<p><b>2021-10-22 16.40</b></p>
<p>Startinfo: fixat länken till email på startsidan. .</p>
<p>Epost: Lagt till en html-editor för meddelandefältet när man skickar mail för att få med lite formatering.</p>
<p>Epost: Lagt till kontroll och hantering av felaktiga/saknade epostadresser när man försöker skicka epost.</p>
<p>Välkomsttext: Förberett klienten för att sysadmin och kanslist ska kunna justera välkomsttexten på startsidan. Inte helt klart vad gäller endpoints.</p>

<p><b>2021-10-15 10.45</b></p>
<p>Startsidan: Justerat välkomsttexten.</p>

<p><b>2021-10-04 09:00</b></p>
<p>Medlemsmatrikel: Bytt till fake-person. Lagt in kontroll så att inte medlemsrollen ser knappen.</p>
<p>Rapport Medlemmar: Buggfix.</p>

<p><b>2021-09-29 17:30</b></p>
<p>Rapport medlemmar: Fixat behörighetskontrollen så att det bör stämma bättre för olika roller - vilka som får ta ut etiketter och skicka epost.</p>
<p>Första sidan: Lagt till några rader text enligt önskemål.</p>

<p><b>2021-09-28 17:50</b></p>
<p>Rapport Medlemmar: Ändrat så att mailikonen kommer med för alla rader för samma medlem om denne har email1 ifyllt.</p>

<p><b>2021-09-27 18:05</b></p>
<p>Hjälp: Lagt tillbaks testvariant för hjälp.</p>
<p>Medlemsmatrikel: Påbörjat test för att ta ut medlemsmatrikel från institutionsvyn.</p>

<p><b>2021-09-24 11:50</b></p>
<p>Admin Electable_Sign: Gjort justeringar i vyn där man lägger till Electable Sign.</p>

<p><b>2021-09-23 18:10</b></p>
<p>Admin Electable_Sign: Gjort justeringar i vyn där man lägger till Electable Sign.</p>

<p><b>2021-09-21 17:45</b></p>
<p>Startsidan: Kommenterat bort behörighetsinformationen.</p>

<p><b>2021-09-20 10:45</b></p>
<p>Rapport Utmärkelser: Fixat sortering och rubrik för institutionsnamn i resultatet.</p>

<p><b>2021-09-16 10:45</b></p>
<p>Admin: Fixat datumformat i samband med låsning av systemet.</p>

<p><b>2021-09-15 14:15</b></p>
<p>Admin: Funktionalitet för att som sysadmin/kanslist kunna låsa systemet på plats.</p>

<p><b>2021-09-14 18:30</b></p>
<p>Stor förändring för att kunna låsa system.</p>
<p>Kanslist + Sysadmin kan fortfarande logga in om systemet är låst.</p>


<p><b>2021-09-13 15:30</b></p>
<p>MinSida: Lagt till möjlighet att radera inlagt foto.</p>
<p>Rapport Uppdrag - Ämbeten: Justerat när mail och etiketter ska tändas upp.</p>

<p><b>2021-09-09 10:05</b></p>
<p>Mötesdetaljer och Sök Möte: Har fixat så att uppdateringen av antal egna deltagare och gäster ska fungera bättre.</p>
<p>Lagt in så att man ser vilken miljö man kör i. Visas bara för lokalt och test.</p>
<p>Registrera inbetalning: Fixat länk till institutionsvyn.</p>

<p><b>2021-09-08 11:40</b></p>
<p>Institution: Fixat så att det går att lägga till medlemmar till K-institutioner (Blivande medlem).</p>
<p>Hjälp: Länkat dokumentation för sysadmin och kanslist.</p>

<p><b>2021-09-08 10:40</b></p>
<p>Nedsättning: Fixat så att korrekt årsavgift visas.</p>
<p>Nedsättning: Fixat så att det går att radera en inlagd nedsättning och att årsavgiften räknas om.</p>
<p>Nedsättning: Buggfix. Nedsättningslistan uppdateras när man byter år.</p>
<p>Nedsättning: Lagt till årsavgift i csv-export.</p>

<p><b>2021-09-07 16:40</b></p>
<p>Nedsättning: Lagt till kontroll om det redan finns en nedsättning med överlappande datum. I så fall ombeds användaren avsluta den tidigare nedsättningen först.</p>

<p><b>2021-09-03 17:40</b></p>
<p>Admin: Ändrat ordningen på menyvalen för Hantera Utmärkelser.</p>
<p>Admin - Lägg till Electable_Sign: Lagt in listbox för institutionstyp.</p>
<p>Rapport - Närvaro på institutionsnivå per år: Kan nu välja distrikt och få upp ett resultat. Dock återstår att få ut rätt resultat.</p>

<p><b>2021-09-02 10:40</b></p>
<p>Mötesdetaljer: Checkboxar för närvarande tas bort om användaren saknar editeringsmöjlighet.</p>
<p>Mötesdetaljer: Fixat så att mötestyp fylls i.</p>
<p>Nedsättning av medlemsavgift: Förberett GUI för att kanslist och sysadmin ska kunna radera inlagd nedsättningsrad.</p>
<p>Rapport Debiteringslängd: Lagt till möjlighet att ange brytdatum samt lagt till info i csv-export.</p>
<p>Rapport Närvaro per institution inom institutionens distrikt: Plockat bort distrikten från listboxen.</p>
<p>Registrering av medlemsavgifter: Fixat så primärinstitution har samma format för alla rader vid export till csv.</p>

<p><b>2021-09-01 07:40</b></p>
<p>Rapport Åldersfördelning: Lagt till så att man ser vilket distrikt statistiken gäller för när man väljer distrikt.</p>
<p>Rapport Åldersfördelning: Lagt till så att man får med vad rapporten gäller för samt datum i csv-exporten.</p>
<p>Nedsättning av medlemsavgift: Lagt till kontroll som gör att det inte går att registrera procentsats över 100.</p>
<p>Avsluta medlemskap: Buggfixar.</p>

<p><b>2021-08-31 17:40</b></p>
<p>Sök Möte: Fixat så att det fungerar även när institution ej är vald.</p>
<p>Sök Möte: För att få med narvaroinformation måste man välja en institution.</p>
<p>Mötesdetaljer: Fixat så att närvaro ska stämma bättre med vilka som är gäster och egna medlemmar.</p>
<p>Mötesdetaljer: Lagt till primärinstitution i mötesdetaljer för deltagande medlemmar.</p>
<p>Lägg till Utmärkelse: Lagt till primärinstitution.</p>
<p>Lägg till Uppdrag: Lagt till primärinstitution.</p>
<p>Sök Möten: Nu får man träff på möten som är inlagda efter dagens datum om man bara fyller i Datum från.</p>
<p>MinSida - Medlemskap: Nu ska kanslist och sysadmin kunna editera avslutade medlemskap.</p>

<p><b>2021-08-30 16:45</b></p>
<p>MinSida: Länk till institution från Medlemsavgifter fixad.</p>
<p>Admin: Flyttat GDPR (avidentifiering) till Stödtabeller.</p>
<p>Rapport Åldersfördelning: Lagt till begränsning av antal år (15 st).</p>
<p>Rapport Orsaker: Möjliggjort val av Storlogen (SL1) i institutionslistan.</p>
<p>Rapport Närvaro på medlemsnivå: Buggfix - rensa valda år.</p>

<p><b>2021-08-27 17:45</b></p>
<p>Lilla Matrikeln: Några layoutfixar.</p>

<p><b>2021-08-25 15:00</b></p>
<p>Rapport Medlemmar: Buggfix. Adresser kommer nu med i Excel-exporten.</p>

<p><b>2021-08-22 23:30</b></p>
<p>Fixat bugg som inte lät folk editera sin egen medlemsbild tex address, SOFT-prenumerant, telefonnummer.</p>
<p>Fixat så när man söker efter möten så kommer inte personer inom samma distrikt hamna som gäster.</p>

<p><b>2021-08-20 11:30</b></p>
<p>Sök Person: Fixat så att kanslist och sysadmin kan söka på inaktiva medlemmar i systemet.</p>
<p>Admin: Lagt till ny meny för att hantera GDPR (avidentifiering av medlemsdata).</p>
<p>Rapport Närvaro på medlemsnivå: Buggfix så att listan med institutioner fungerar för olika användartyper.</p>
<p>Versionsinformation: Ändrat title-text.</p>
<p>Närvaro på medlemsnivå: Buggfix årtal.</p>

<p><b>2021-08-19 13:20</b></p>
<p>Avsluta medlemskap i Storlogen: Lagt till ny upphörandeanledning.</p>
<p>Rapport Medlemmar: Lagt till primärinstitution i resultat.</p>
<p>Rapport Medlemmar: Lagt till primärinstitution i exportfilen. Gjort om datastrukturen för det som skickas till excelexporten.</p>
<p>Mötesdetaljer: Fixat så att behörighetskontrollen förhoppningsvis ska fungera bättre.</p>


<p><b>2021-08-18 11:20</b></p>
<p>Lagt till distrikt i Åldersfördelningsrapport.</p>
<p>Fixat så SOFT-prenumeranter i medlemsrapport fungerar korrekt.</p>
<p>Fixat sökning av lägermedlem i medlemsrapport.</p>
<p>Fixat Avrundning i matrikel.</p>
<p>Uppdatera utmärkelser: Ändring har gjorts för att eventuellt bli av med 403 forbidden error vid uppdatering av utmärkelser för vissa användare.</p>
<p>Rapport Orsaker: Lagt till primärinstitution i både resultatlista och csv/excel-export.</p>
<p>Rapport Orsaker: Fixat så att distrikt hanteras.</p>
<p>Rapport Orsaker: Fixat så att år skrivs ut för varje rad vid export till csv/excel.</p>

<p><b>2021-08-16 20.00</b></p>
<p>Hjälpdokument: Vanliga medlemmar kan se och öppna både medlems- och ämbetsmanual.</p>
<p>Glömt lösenord: Gjort fältet Medlemsnummer lite bredare.</p>
<p>Skapa ny medlem: Panelen Hemadress ska vara öppen från början.</p>
<p>Devinfo: Plockat bort utskrifter i vissa vyer som används under utveckling.</p>
<p>Lilla Matrikeln: Plockat bort yrkestitel.</p>
<p>Rapport Åldersfördelning: Fixat export till csv/excel så att datat kommer i kolumner.</p>
<p>Rapport Åldersfördelning: Fixat Totalt loger och Totalt läger så att felmeddelandet försvinner.</p>

<p><b>2021-08-15 20.30</b></p>
<p>Lagt till permissions och möjlighet för systemanvändare att göra undantag genom att lägga till uppdrag/ämbeten i institutioner någon ej är medlem i.</p>

<p><b>2021-08-10 19.30</b></p>
<p>Lagt till funktion för att ta bort medlemskap i storloge.</p>
<p>Fixat bugg så man kan söka på medlemsId när man lägger till nytt medlemskap.</p>
<p>Fixat bugg som gav 400-error när man försökte skapa nytt medlemskap i Ny medlem.</p>

<p><b>2021-07-31 20.30</b></p>
<p>Ändrat rapport: Närvarostatistik per möte, lagt till distrikt, får deadlock-fel ibland, inte helt klar.</p>
<p>Fixat rapport: Närvaro på institutionsnivå/månad, lagt till distrikt och ändrat hur den hämtar data.</p>
<p>Fixat rapport:Närvaro på institutionsnivå/år, lagt till distrikt och ändrat hur den hämtar data.</p>
<p>Fixat admingränssnitt: Hantera office_committee så den tar bor FK också, ska inte längre ge fel när man tar bort poster</p>
<p>Fixat databasbuggar: Pekat om föreningsroller så det stämmer överens med verkligheten.</p>

<p><b>2021-07-21 16.30</b></p>
<p>Fixat rapport: Närvaro på medlemsnivå så den visar primärloge</p>

<p><b>2021-07-20 16.30</b></p>
<p>Tagit bort utdaterad Behörighetsrollskolumn från admingränssnittet för hantering av OfficeCommittees</p>
<p>Fixat rapport Närvarostatistik per möte</p>

<p><b>2021-07-09 09.30</b></p>
<p>Sök möte: Ska gå att söka möte via huvudmenyn igen.</p>
<p>Admin - Institution type: Grupp innehåller gruppnamn i klartext. I lägg till- och ändra-läget får man en listbox. Samma för filtrering.</p>
<p>Aktiv tid: En liten ändring har gjorts men tveksamt om det är det som är problemet. Har svårt att återskapa.</p>
<p>Rapport Närvaro institutionsnivå per månad: Antal egnas besök i annan institution ska bli mer korrekt.</p>
<p>Admin - Systembehörigheter: Gruppering av systembehörigheter på plats.</p>
<p>Addera medlemmar till Storlogen: Ändring gjort så att man får upp fler medlemmar som man kan välja att addera.</p>
<p>Rapport - Närvarostatistik per möte: Ska endast ta med Ordinarie möten. Fixat förutom för Totalt läger.</p>

<p><b>2021-07-06 13.50</b></p>
<p>Fixat att kunnna lägga till medlem till storloge</p>
<p>Fixat så alla roller kan se alla permissions</p>

<p><b>2021-06-21 13.50</b></p>
<p>Institutionsvyn: Gjort vissa förändringar gällande Hemside-länkar.</p>

<p><b>2021-06-21 11.30</b></p>
<p>Buggfix: Länk från mötesvyn till medlem (när man lägger till deltagare).</p>
<p>Admin: Hantera systembehörigheter - lagt till information om vilka behörighetsroller som hör till olika systembehörigheter.</p>

<p><b>2021-06-18 14.00</b></p>
<p>Fixat så att rätt domän ges ut när man hämtar permission.</p>

<p><b>2021-06-18 12.00</b></p>
<p>MinSida: När man byter foto ska fotot vara uppdaterat på MinSida när man kommer tillbaks.</p>

<p><b>2021-06-16 17.30</b></p>
<p>Lagt till så FeeCalculation körs när ny medlem skapas, ska löst bugg där nya medlemmar inte visas i betalningar.</p>
<p>Fixat så Kanslist så den visas för medlemmar.</p>
<p>Lagt till loggning för vissa funktioner.</p>

<p><b>2021-06-15 17.30</b></p>
<p>Admin: Lagt till funktionalitet för att kunna lägga till, uppdatera samt radera superanvändare.</p>
<p>Admin: Har skapat nya vyer samt funktionalitet för att kunna lägga till, uppdatera samt radera Sign_Type.</p>
<p>Rapport Uppdrag: Fixat så att fälten kommer i rätt ordning.</p>
<p>Admin: Styrt om länken för att komma till Skapa ny institution från Admin-menyn.</p>
<p>MinSida: Fixat bugg som gjorde att valt datum blev en dag tidigare än det valda datumet.</p>

<p><b>2021-06-14 14.10</b></p>
<p>Admin: Lagt in kontroll att man måste köra som Systemadministratör för att kunna hantera vissa sysadmin-funktioner.</p>

<p><b>2021-06-10 16.55</b></p>
<p>Buggfix: Foton visas inte på MinSida.</p>

<p><b>2021-06-09 16.30</b></p>
<p>Generellt: Gjort genomgripande förändringar i hur navigering, behörighetskontroller och förpopulering av sökvyer för att det <br>ska bli mer stabilt när man hoppar mellan olika roller och vyer.</p>
<p>Skapa ny medlem: Har skapat en egen komponent/vy för att hantera registrering av ny medlem.</p>
<p>Har plockat bort menyvalet Skapa ny medlem från Admin-delen i navigeringsvyn. Finns i institutionsvyn för de som har behörighet att skapa ny medlem.</p>
<p>Prestandaförbättringar: I och med de ändringar som gjorts gällande navigering, behörighetskontroller har även prestandan blivit bättre.</p>

<p><b>2021-06-03 15.00</b></p>
<p>Loggar nu medlemmars viktiga handlingar till en databastabell.</p>
<p>Ändrat så PermissionService GetPermissions kollar på aktuellt datum för medlemskap, bugg som fick vissa medlemmar att crasha.</p>

<p><b>2021-05-31 18.30</b></p>
<p>Institutionsvyn: Fix så att inte Tillhör ska fyllas på med fler institutioner när man går fram och tillbaks till vyn.</p>
<p>Sök medlemmar: När man väljer att se medlemmar från institutionsvyn ska nu institutionstyp bli förvald.</p>
<p>Sök medlemmar: Fixat så att checkboxen dyker upp för alla i resultatlistan för att man ska kunna välja vilka man vill kunna ta ut etiketter för.</p>
<p>Admin: Plockat bort möjlighet att lägga till/editera Behörighetsroll i vyn Hantera Uppdrag.</p>
<p>Admin: Koppla Uppdrag med behörighetsroll-> Fixat så att de övre rubrikerna markerar rätt kolumner.</p>
<p>Admin: Lagt till filtreringsfält för vyn Lista Uppdrag/Ämbeten.</p>
<p>Hjälpdokument: Länkat in nyare pdf-dokument med hjälp för Ämbetsmän (210423)</p>
<p>Diverse förändringar gällande routing för att det ska fungera bättre. Ska justeras på ytterligare ställen.</p>

<p><b>2021-05-27 14.00</b></p>
<p>Lagt till så man endast får upp de roller som är releventa för den Institutionstyp ett ämbete har i "Koppla Systembehörigheter <-> Behörighetsroll"</p>
<p>Fixat bugg i FeeCalculations, måste återställa databas innan denna ändring går igenom.</p>

<p><b>2021-05-25 11.00</b></p>
<p>Fixat bugg som inte lät vanliga medlemmar att logga in.</p>
<p>Lagt till cache för roller och behörighet.</p>

<p><b>2021-05-25 9.30</b></p>
<p>Stora förändringar av hur behörigheter och behörighetsroller hanteras i systemet. Nu är det möjligt att koppla behörighetsroll till ett specifikt uppdrag.</p>
<p>Rollistan: Nu får användaren upp de medlemskap - samt de aktuella uppdrag denne har - i listan i huvudmenyn.</p>

<p><b>2021-04-18 17.50</b></p>
<p>Rapport Uppdrag-Ämbeten: Endast en checkbox per medlem när de förekommer flera gånger i sökresultatet.</p>
<p>Rapport Medlemmar: Endast en checkbox per medlem när de förekommer flera gånger i sökresultatet.</p>
<p>Sök Person: Översyn av mailfunktionalitet.</p>

<p><b>2021-04-13 20.00</b></p>
<p>Rapport Utmärkelser: Fixat så att endast de medlemmar som har Epost1 får en checkbox.</p>
<p>Rapport Utmärkelser: Fixat till Epost-funktionen.</p>
<p>Rapport Utmärkelser: Fixat så att enbart valda medlemmar kommer med vid etikett-skapande.</p>
<p>Sök person: Fixat etikett-export.</p>


<p>Sök Möte: Har fixat så att vyn Sök Möte ska fungera bättre vad gäller automatiskt val av institutionstyp i sökvyn när man hoppar runt och byter roll.</p>
<p>Admin-val i menyn för PS: Har plockat bort att PS får Admin-menyn (med möjlighet att skapa ny medlem i Orden).</p>
<p>Admin-delarna: En rad förändringar vad gäller kolumner, kolumnnamn samt ordningen på dessa.</p>
<p>Admin-delarna: Skapat nytt menyval under Systemadministration + en ny vy för att SysAdmin ska kunna editera Behörighetsroll och koppla ihop det med Systembehörighet och Ämbete. Backend ej på plats.</p>

<p><b>2021-04-06 15.15</b></p>
<p>Admin - Fixat kolumnnamn och Excel-exporter för ett flertal vyer i enlighet med Jans mail fre 2021-04-02 19:49.</p>
31

<p><b>2021-04-06 12.30</b></p>
<p>Admin - Lista Uppdrag: Ändrat rubrik till Lista Uppdrag/Ämbeten. Lagt till ytterligare fält/kolumner. Fixat kolumnnamn. Fixat så kolumnerna kommer i samma ordning i Excel-exporten.</p>

<p><b>2021-04-06 11.35</b></p>
<p>Sök Möten: Buggfix så att inte listan med valbara institutioner ska fyllas på med dubbletter.</p>
<p>Admin: Lagt till kontroll för att se om Administrations-delen ska visas i huvudmenyn eller inte.</p>

<p><b>2021-04-01 15.35</b></p>
<p>Nedsättning av medlemsavgift: Lagt till Primärinstitution.</p>


<p><b>2021-04-01 09.50</b></p>
<p>Sök Möte: Fixat så att användartypens institution blir förvald.</p>
<p>Admin - Lista Uppdrag: Första variant på vy för att lista Uppdrag/Ämbeten.</p>

<p><b>2021-03-30 11.55</b></p>
<p>Mötesdetaljer: Bugfix så att det går att redigera möte och att listan med mötesresultat uppdateras när man går Tillbaka.</p>

<p><b>2021-03-30 11.35</b></p>
<p>Möten: Fixat så att institution ska sättas i listboxen när man hoppar mellan olika roller och kommer till möten via institutionsvyn.</p>

<p><b>2021-03-30 09.50</b></p>
<p>Registrera mötesnärvaro: Buggfix så att knappen Registrera möten enbart visas när den ska visas.</p>

<p><b>2021-03-29 20.20</b></p>
<p>Admin: Förbättrat GUI framförallt i editeringsläget.</p>
<p>Rapport Utmärkelser: Implementerat mailfunktionaliteten i rapporten.</p>
<p>Flertalet rapporter (bland annat Åldersfördelning): Fixat så att det är möjligt att välja innevarande år.</p>
<p>Sök Möten: När man registrerat ett nytt möte sker en ny sökning för att visa det nya mötet i listan.</p>

<p><b>2021-03-29 09.10</b></p>
<p>Administration: CRUD tillagt på i stort sett samtliga befintliga vyer i admin-delarna.</p>
<p>Mobilläge: Fixat så att menyn drar ihop sig när man klickar på menyval. Bland annat drar menyn ihop sig när man får upp logga-ut dialogen.</p>
<p>Mobilläge: Lagt till kontroll att användaren har rätt att se admin-delarna.</p>

<p><b>2021-03-25 16.20</b></p>
<p>Matrikelkort: Ändring av hur behörighetskontrollen går till.</p>

<p><b>2021-03-25 13.45</b></p>
<p>Matrikelkort: Rättning för att förhoppningsvis få med allt data som ska visas.</p>

<p><b>2021-03-25 11.30</b></p>
<p>Registrera inbetalning: Lagt till Primärinstitution.</p>
<p>MinSida: Gjort ändring av behörighetskontroll för Lägg till-knappen för Uppdrag och Utmärkelser.</p>

<p><b>2021-03-24 14.55</b></p>
<p>Admin: Ytterligare admin-vyer har förberetts (klientdelarna). Utseende och fältnamn ska justeras.</p>
<p>Registrera ny medlem i Orden: Om man trycker på Avbryt ska aktuell info rensas bort så att man börjar om när man kommer tillbaks.</p>

<p><b>2021-03-23 17.35</b></p>
<p>Admin: Förberett klientvyer för institutionstyp - institution type (CRUD)</p>
<p>Admin: Förberett klientvyer för institutionsgrupp - institution group (CRUD)</p>
<p>Admin: Förberett klientvyer för uppdragstyp - office type (CRUD)</p>

<p><b>2021-03-23 13.20</b></p>
<p>Registrera inbetalning: Excel ska ha korrekt data.</p>
<p>Nedsättning medlemsavgift: Kan välja 5 år framåt i tiden.</p>
<p>Hantera medlemsavigfter: Kan välja 5 år framåt i tiden.</p>
<p>Sök institution: I testmiljön sätts institutionstyp först men sedan när sökningen sker försvinner valet av någon konstig anledning.</p>

<p><b>2021-03-22 18.25</b></p>
<p>Sök institution: Fixat så att institutionstyp väljs automatiskt för Medlem och att sökningen sker automatiskt.</p>
<p>Söke möte: Institution sätts automatiskt till den institution aktuell användartyp har koppling till. Sökning sker automatiskt.</p>
<p>Registrera avgift: Fixat så att Spara-knappen får rätt text och är aktiverad/inaktiverad korrekt.</p>
<p>Registrera avgift: Fixat så att man ser även registrerade framtida medlemsavgifter för vald institution.</p>

<p><b>2021-03-19 08.45</b></p>
<p>Registrera inbetalningar: Buggfix för att primärinstitution ska fungera.</p>
<p>Registrera inbetalningar: Fixat så att det går att filtrera på primärinstitution.</p>
<p>Registrera inbetalningar: Bytt multicheckboxen för Fullbetald till en dropdown (Visa allt, Ja, Nej)</p>

<p><b>2021-03-18 11.30</b></p>
<p>Registrera inbetalningar: Editering av inbetalning ska fungera.</p>
<p>Registrera inbetalningar: Radera inbetalning ska fungera.</p>
<p>Registrera inbetalningar: När sista inbetalningsraden raderas dras tabellraden ihop.</p>
<p>Registrera inbetalningar: Kontroll att det är ett fullständigt datum som matats in.</p>
<p>Registrera inbetalningar: Knappen Registrera betalning aktiveras först när man fyllt i ett datum, belopp samt valt en medlem.</p>
<p>Registrera inbetalningar: Saldot uppdateras när man editerar en inbetalning eller raderar en inbetalning.</p>
<p>Registrera årsavgift: Saldot för alla medlemmar i aktuell institution räknas om.</p>
<p>Nedsättning av årsavgift: Saldot för aktuell medlem räknas om.</p>
<p>Registrera inbetalningar: Lagt till primärinstitution på nytt i listan. Kommer även med i Excel-filen.</p>

<p><b>2021-03-17 10.30</b></p>
<p>Fixat Excelexport. Nu tas även hänsyn till filtreringen så att endast de rader man filtrerat ut kommer med i Excel-filen.</p>
<p>Registrera medlemsavgifter: Lagt tillbaks primärinstitution.</p>

<p><b>2021-03-16 13.40</b></p>
<p>Sök person: I mobil ska sökvyn stängas när man trycker på sök-knappen. Har även gjort så att den öppnas när man trycker på Rensa-knappen.</p>
<p>Sök Institution: Som medlem ska man inte få upp UT1 m m.</p>
<p>Loggan i headern: Har fixat så att den ligger till vänster i headern när man kör på mobil.</p>

<p><b>2021-03-16 13.15</b></p>
<p>MinSida: Saldo får röd text när det är under 0.</p>
<p>Registrera medlemsavgift: Lagt till primärinstitution i listan.</p>
<p>Registrera medlemsavgift: Lagt till hyperlänkar på memberid och primärinstitution.</p>

<p><b>2021-03-16 01.45</b></p>
<p>MinSida: Medlemsavgifter använder de nya beräkningarna.</p>
<p>Registrera medlemsavgifter: Har anpassat vyn så att den använder de nya beräkningarna samt lagt till/bytt ut vissa fält.</p>
<p>Sök person: Medlem ska inte få upp UT1, AVGBREV1 m m</p>
<p>Sök institutioner: Medlem ska inte få upp UT1, AVGBREV1 m m</p>
<p>Sök möte: Medlem ska bara se sin egen institutions möten när vyn öppnas.</p>
<p>Institution - Sök möte: Medlem ska bara se möten för vald institution när vyn öppnas.</p>
<p>Institution - Koppla medlem: Detta bör fungera bättre nu. Det var en behörighet som blivit urkryssad av misstag.</p>

<p><b>2021-03-13 22.35</b></p>
<p>Adminvyer: Fixat till diverse småbuggar. Gjort det möjligt att spara i olika vyer och att listorna uppdateras med de nya posterna.</p>
<p>Institutionsvyn: Gjort förändringar i funktionaliteten för att koppla medlemmar till olika institutionstyper.</p>

<p><b>2021-03-11 18.30</b></p>
<p>Byt lösenord: Lagt till möjlighet att skicka kontoinformation till medlemmen som fått nytt lösenord med inloggningsinfo.</p>

<p><b>2021-03-11 13.50</b></p>
<p>MinSida: Medlemsavgifter - Buggfix (första årets betalningar visades inte).</p>

<p><b>2021-03-11 12.15</b></p>
<p>MinSida: Medlemsavgifter - har gjort ett test för att få en expanderbar tabell.</p>

<p><b>2021-03-10 09.50</b></p>
<p>MinSida: Medlemsavgifter - Ändrat sortering samt fixat så att RF kan se medlemsavgifter för medlemmar i det läger denne administrerar.</p>

<p><b>2021-03-09 14.45</b></p>
<p>Lägg till Uppdrag: Söker enbart bland de medlemmar som har aktuellt medlemskap i vald institution.</p>
<p>Lägg till Utmärkelse: Söker enbart bland de medlemmar som har aktuellt medlemskap i vald institution.</p>


<p><b>2021-03-08 08.50</b></p>
<p>Rapport Medlemmar: Buggfix. Mobiltelefonnummer kom inte med tidigare i csv-filen.</p>
<p>Rapport Medlemmar: Etikett-knappen ska tändas först när man kryssat i någon medlem och användaren har behörighet att ta ut etiketter.</p>
<p>Rapport Institutioner per distrikt: Lagt till filtreringsfunktionalitet.</p>

<p><b>2021-03-08 08.25</b></p>
<p>Rapport Medlemmar: Lagt till Slutdatum i resultattabellen.</p>
<p>Rapport Debiteringslängd: Lagt till spinner.</p>
<p>Rapport Institutioner per distrikt: Lagt till spinner.</p>
<p>Rapport Orsaker: Fixat så att resultatsiffran ska stämma.</p>
<p>Skapa ny institution: Fixat så att man inte får ett felmeddelande (angående permissions).</p>

<p><b>2021-03-06 17.05</b></p>
<p>Implementering av behörighetskontroller.</p>

<p><b>2021-03-05 18.55</b></p>
<p>Ändringar för att får ordning på problemen med roller och behörigheter.</p>

<p><b>2021-03-05 14.25</b></p>
<p>Eventuell buggfix för att problemet med att rollen inte stämmer med det man valt.</p>

<p><b>2021-03-05 11.30</b></p>
<p>Eventuell buggfix för att problemet med att rollen inte stämmer med det man valt.</p>

<p><b>2021-03-05 09.55</b></p>
<p>Rapport Gottstående1: Lagt på behörighetskontroll.</p>
<p>Rapport Gottstående2: Lagt på behörighetskontroll.</p>

<p><b>2021-03-04 21.25</b></p>
<p>MinSida/Medlemskap: Uppdatera medlemskapsgruppen när man byter primärinstitution för medlem.</p>
<p>Lägg till Utmärkelse: Saker ligger kvar när man lämnar vyn och kommer tillbaks. Fixat.</p>
<p>Lägg till Ämbete: Saker ligger kvar när man lämnar vyn och kommer tillbaks. Fixat.</p>
<p>Sökning av institutioner och distrikt (specialkomponent): Har lagt till knapp i headern [Rensa] så att man kan rensa filtreringen.</p>
<p>Rapport Gottstående2: Mesta klart på frontend. Saknas lite på backend.</p>
<p>Rapport Närvaro på medlemsnivå: Årtalen rensas inte när man trycker på Rensa-knappen. Fixat.</p>
<p>Video: Gjort ett första test för att se att videolänkningarna till Azure fungerar.</p>
<p>Lägg till ny medlem till läger: Fixat så att institutionslistan enbart innehåller brödraloger om det är ett brödraläger.</p>
<p>Lägg till ny medlem till läger: Fixat så att institutionslistan är korrekt sorterad.</p>
<p>Lägg till ny medlem till läger: Fixat så att institutionslistan inte innehåller AV1, AVGBREV m m.</p>

<p><b>2021-03-03 18.05</b></p>
<p>Sök möte: Lagt till behörighetskontroll för knappen Registrera möte.</p>
<p>Mail: Lagt till så att from-adress hämtas från personens institutionskoppling.</p>

<p><b>2021-03-02 18.05</b></p>
<p>Återställning av lösenord: Lagt loggan överst så att det funkar med olika skärmstorlekar. Bytt label på lösenordsfältet.</p>
<p>Medlemsvy: Fixat så att undermenyn för medlemskap inte visas om det saknas innehåll (ingen behörighet att hantera medlemskap, t ex FS).</p>
<p>Medlemsvy: FS får endast se Medlemsavgifter för medlemmar i den institution denne administrerar.</p>
<p>Hantera avgifter: Välj år plockas bort om man väljer Hantera avgifter i listan.</p>
<p>Registrera inbetalning: Dölj översta delen när man ska hantera mail.</p>
<p>Sök institution: Lagt till Rensa-knapp i mobilläge.</p>
<p>Sök institution: Söker automatiskt om det finns en institutionstyp kopplad till aktuell användare/roll, vilket det inte gör för kanslist och sysadmin.</p>
<p>Sök person: Söker automatiskt när man kommer in och det automatiskt fyllts i information kopplad till aktuell användare/roll.</p>

<p><b>2021-03-01 18.10</b></p>
<p>Återställ lösenord. Fixat så att det ska se bättre ut och fungera bättre. Hantering av dialogrutor och info på ett bättre sätt.</p>
<p>Nedsättning av medlemsavgift: Året skickas med för att listan ska innehålla medlemmar som har nedsättning för det år man valt.</p>
<p>Nedsättning av medlemsavgift: Bytt till filtreringsbar medlemslista.</p>
<p>Nedsättning av medlemsavgift: Avlidna medlemmar ska inte komma med i medlemslistan.</p>
<p>Nedsättning av medlemsavgift: Fixat så att allt data kommer med i csv-filen.</p>
<p>Registrera medlemsavgift: Fixat så att allt data kommer med i csv-filen.</p>
<p>Registrera medlemsavgift: Innevarande år blir default i listan för år.</p>
<p>Registrera medlemsavgift: Fixat buggen som fanns när man registrerar inbetalning för flera samtidigt.</p>
<p>Registrera medlemsavgift: Fixat så att det ska blir ett rött kryss i kolumnen fullbetald om medlemmen inte betalt någonting ännu för valt år.</p>
<p>Registrera medlemsavgift: Restkolumnen sätts till svart 0 om medlemmen är fullbetald.</p>
<p>Registrera medlemsavgift: Lagt till funktionalitet för att kunna skicka mail till valda medlemmar.</p>
<p>Hantera medlemsavgift: Listar alla årsavgifter för aktuell institution.</p>
<p>Hantera medlemsavgift: Lagt till möjlighet att ändra årsavgifter för aktuell institution.</p>
<p>Hantera medlemsavgift: Ändrat sorteringen på medlemsavgifterna så att man får det senaste året föst.</p>


<p><b>2021-02-26 09.10</b></p>
<p>Bytt informationstext på startsidan.</p>

<p><b>2021-02-25 17.20</b></p>
<p>Länken till Medlemsavgifter i institutionsvyn har gjorts om till en knapp. Dessutom fixat så att kanslist kan komma till medlemsavgiftsvyerna.</p>
<p>Lagt till tooltip för special-checkboxen i vyn Registrera medlemsavgifter.</p>
<p>Fixat så att kanslist ska få upp alla institutioner som aktuell medlem varit medlem i när kanslist ska lägga till Uppdrag/Utmärkelse för en medlem. Återstår att sökningen ska få träff även på icke-aktuella medlemmar.</p>
<p>Fixat så att MinSida ser bättre ut på mobilskärm.</p>
<p>SOFT-prenumerant: Rapport fixad så att det blir rätt kolumnrubriker och att kolumner kommer i önskad ordning.</p>
<p>Byt primärinstitution: Gjort så att inte den aktuella primärinstitutionen kommer med i listan.</p>
<p>Koppla medlem till läger: Tillägg av Avbryt-knapp</p>
<p>Ladda upp foto: Tillägg av Avbryt-knapp.</p>
<p>Samtliga adminvyer: Tillägg av markering vid hovring över tabellrader.</p>
<p>Rapport Orsaker: Tillägg av orsak i både resultatlista och csv-fil.</p>
<p>MinSida: Fixat så att kanslist kan se alla medlemmars inbetalda medlemsavgifter.</p>
<p>Registrera mötesnärvaro: Lagt till primärinstitution i närvarolista och i listan med egna/gäster.</p>

<p><b>2021-02-11 18.15</b></p>
<p>Lagt till funktionalitet så att samtliga rapportsökvyer rensas i samband med att de öppnas. Fungerar även när man använder webbläsarens bakåt och framåtknapper.</p>

<p><b>2021-02-11 12.00</b></p>
<p>Fixat så att vyn för sökning av fadder ska visas i fullbredd.</p>

<p><b>2021-02-11 11.00</b></p>
<p>Registrera medlemsavgifter: Kan lägga till/uppdatera medlemsavgifter för en/flera medlemmar.</p>
<p>Nedsättning medlemsavgift: Nu går det att lägga till och uppdatera nedsättningar.</p>

<p><b>2021-02-10 11.30</b></p>
<p>Registrera betalning: Fixat klientdelarna så att man nu ska kunna registrera betalningar för en eller fler medlemmar i samma vy.</p>
<p>Registrera betalning: Tagit bort gamla vyn för multiregistrering av betalningar.</p>
<p>Mailvy: Fixat så att mailvyn kommer i eget fönster.</p>
<p>Mailvy: Fixat så att det går att gå tillbaks och plocka bort/lägga till personer som man vill skicka mail till.</p>
<p>Rapport Medlemmar: Tillägg av mailfunktionalitet från rapporten. Går även att gå tillbaks och plocka bort/lägga till personer.</p>
<p>Admin: Organiserat om alla vyer samt routingen för adminvyerna.</p>
<p>Medlemsavgifter: Flyttat om i layouten för vyn där man hanterar årsavgifterna för institutioner.</p>
<p>Medlemsavgifter: Ändrat datumformatet för datumfält i Nedsättning av medlemsavgifter.</p>
<p>Rapport Gottstående 1: Första version av rapporten. Saknas möjlighet att skapa csv-fil.</p>

<p><b>2021-02-03 14.40</b></p>
<p>Admin: Förberett vyer och funktionalitet i klienten för att lägga till Uppdrag och Utmärkelser.</p>
<p>Admin: Förberett funktionalitet och GUI för att kunna radera uppdrag och utmärkelser.</p>
<p>Admin: Ensat GUI för de olika admin-tabellerna så att Lägg till-knapp + övrigt ligger på samma ställen i alla vyer.</p>
<p>Admin: Påbörjat klientdelarna för att hantera Electable Signs.</p>

<p><b>2021-02-02 10.00</b></p>
<p>Rapport Gottstående 1: Ett första utkast för klientdelarna.</p>

<p><b>2021-02-01 11.25</b></p>
<p>Registrera inbetalning: Diverse GUI-fixar (bland annat öppna/stänga alla rader i tabellen).</p>
<p>Registrera inbetalning: Tillägg av knapp + funktionalitet för att generera CSV-fil av tabellinnehållet.</p>
<p>Medlemsavgifter: Ändrat ordningen på innehållet i listboxen 'Välj åtgärd'.</p>
<p>Registrera möte har flyttats från institutionsvyn till Sök möte-vyn.</p>
<p>Rubrik Notering har ändrats till Kommentar överallt.</p>
<p>Rapport Närvarostatistik per möte: Lagt till hyperlänk till mötesdetaljer från mötesdatum. Återstår att implementera behörighetskontroller.</p>
<p>Bytt namn på rapport Närvaro på institutionsnivå --> Närvaro på institutionsnivå per år.</p>
<p>Bytt plats i menyn mellan Närvaro per institution inom institutionens distrikt och Närvaro på institutionsnivå per månad.</p>
<p>Bytt namn på rubrik för t ex Antal egnas besök i annan loge --> Antal egnas besök i annan inst. Finns säkert fler ställen där ni vill ändra detta.</p>
<p>Nedsättning av medlemsavgift: Har bytt tabellen mot liknande variant som i Registrera medlemsavgift för att få filtrering, sortering m m.</p>
<p>Nedsättning av medlemsavgift: Förberett GUI för att kunna editera poster i tabellen. Lagt till hyperlänk på medlemsid.</p>
<p>Nedsättning av medlemsavgift: Tillägg av funktionalitet för att generera CSV-fil för tabellinnehåll.</p>
<p>Rapport Orsaker: Lagt till funktionalitet för att generera CSV-fil både vid sökning på institution/Totalt antal loger/läger.</p>
<p>Sök person: Tillägg av mail-vy.</p>

<p><b>2021-01-20 09.25</b></p>
<p>Registrera inbetalning - testar ny vy.</p>

<p><b>2021-01-18 16.45</b></p>
<p>Buggfix - asynkproblem i admin-delarna i vissa lägen.</p>

<p><b>2021-01-18 10.40</b></p>
<p>Nya admin-vyer: Uppdrag, Utskott, Office Committee, Electable Committees</p>

<p><b>2021-01-12 11.00</b></p>
<p>Tillägg av två nya claims.</p>

<p><b>2021-01-10 18.00</b></p>
<p>Rapport Mötesnärvaro på medlemsnivå: Visst arbete utförts. Resultatet listas inte på rätt sätt just nu. Excel ska läggas till.</p>

<p><b>2021-01-07 11.45</b></p>
<p>Mötesdetaljer: Buggfix - fick felmeddelande när man ska lägga till deltagare till möte.</p>

<p><b>2020-12-26 14.10</b></p>
<p>Gjort vissa ändringar när det gäller Sök möte. Datum ska komma med för alla poster nu. Ändrat fältordningen i resultatlistan.</p>

<p><b>2020-12-22 16.50</b></p>
<p>Gjort vissa ändringar när det gäller Sök möte. Använder samma vy när man går via huvudmeny och via institution.</p>

<p><b>2020-12-15 11:30</b></p>
<p>Rapport: Ämbeten - Excelexport</p>
<p>Rapport: Analys medlemsflöde - Excelexport</p>


<p><b>2020-12-11 19:30</b></p>
<p>Fixat menyer ovanför rapportresultat. Ska användas till knappar för att skapa Excel-filer, Skicka E-post och skapa underlagsfiler för etiketter.</p>
<p>För nedanstående rapporter går det att generera Excel-filer:</p>
<p>- Medlemmar</p>
<p>- Debiteringslängd</p>
<p>- Födelsedagslista</p>
<p>- Institutioner per distrikt</p>
<p>- Nya institutioner per år</p>
<p>- Narvarostatistik per möte</p>
<p>- Närvaro per institution inom institutionens distrikt</p>
<p>- Närvaro på institutionsnivå per månad</p>
<p>- Närvaro på institutionsnivå</p>
<p>- Ämbeten och Utmärkelser: För dessa går det att skapa Excel-filer men det ska adderas en hel del ytterligare kolumner.</p>
<br>
<p>Lagt till funktionalitet för att kunna skicka Epost från några vyer. Det egna epost-programmet öppnas upp med valda personers epostadresser valda.</p>
<br>
<p>För nedanstående rapporter går det att generera csv-filer för etikettutskrifter:</p>
<p>- Medlemmar</p>
<p>- Ämbeten</p>
<p>- Utmärkelser</p>

<p><b>2020-12-07 18:15</b></p>
<p>Rapport Åldersfördelning. Buggfix när man byter institution så att siffrorna blir rätt i rapporten.</p>
<p>Sök medlem: GUI-fixar. Fixat menubar på resultattabellen med knapp för etiketter och epost.</p>
<p>Sök möten. Fixat menubar för resultattabellen. Knapp för att skapa Excel-fil.</p>
<p>Sök möten via instititutionsvyn - GUI fixar.</p>

<p><b>2020-12-07 09:15</b></p>
<p>Rapport: Medlemmar</p>
<p>Rapport: Närvaro per institution inom institutionens distrikt</p>

<p><b>2020-12-06 18:15</b></p>
<p>Förfinat GUI för rapporter.</p>
<p>Diverse fixar i applikationen.</p>
<p>Excel för några rapporter.</p>

<p><b>2020-12-06 13:50</b></p>
<p>Buggfix när man skapar ny medlem i Orden.</p>

<p><b>2020-12-06 12:45</b></p>
<p>Buggfix när man skapar ny medlem i Orden.</p>

<p><b>2020-12-06 12:15</b></p>
<p>Buggfix när man skapar ny medlem i Orden.</p>

<p><b>2020-12-02 21:15</b></p>
<p>Fortsatt arbete med rapporter. Medlemsrapport, Närvaro på medlemsnivå, Närvaro på institutionsnivå per månad m m</p>
<p>Flyttat SOFT-prenumerant till medlemsgruppen på MinSida.</p>

<p><b>2020-12-01 19:30</b></p>
<p>Framförallt har det skett arbeten kring rapporterna. Det återstår dock en del jobb innan de är helt på plats.</p>

<p><b>2020-11-27 13:00</b></p>
<p>Buggfix: Problem att se och använda menyn på första sidan i mobilläge.</p>

<p><b>2020-11-27 10:45</b></p>
<p>Fixat bugg: Medlemsrollen kan ändra andra medlemmars information när de tillhör samma institution. Fixat så att det inte går.</p>
<p>Fixat bugg: Registrering av gäst som tillhör Storlogen läggs till som vanlig logemedlem. Fixat så att medlemmen läggs till som gäst från Storlogen.</p>
<p>Rapport medlemmar har gjorts om i klienten. Återstår visst jobb på backend.</p>
<p>Rapport Närvaro på medlemsnivå - finns en början men är inte klar.</p>


<p><b>2020-11-25</b></p>
<p>Byggt om klientdelarna för Rapport Medlemmar så att det överensstämmer med Jans önskemål.</p>
<p>Fixat Lägg till uppdrag och utmärkelser från MinSida så att sysadmin/kanslist och PF/PS fungerar.

<p><b>2020-11-24</b></p>
<p>Pkt 124: Avsluta medlemskap i läger - institutionslistan tom. Fixat.</p>



<p><b>2020-11-24 11:25</b></p>
<p>Pkt 123: Saknas Rensa-knapp när man ska koppla medlem till läger. Fixat.</p>
<p>Pkt 116: Spara och rensa-knappar flyter ihop när man editerar Uppdrag och minskar browser-fönster. Samma sak fixad för Utmärkelser.</p>
<p>Pkt 113-114: Lägg till-knapp för Uppdrag och Utmärkelser för PF. Ska kontrollera varför man inte alltid får upp medlemmen i kopplingsvyn.</p>
<p>Pkt 105: Mötesvyn - Ändra -> Förhindrat att man kan klicka på aktiva länkar i editeringsläget.</p>
<p>Pkt 103-104: MinSida och Institutionsvyn. Inaktivera aktiva länkar i editeringsläget. Fixat.</p>
<p>Pkt 93: Analys medlemsflöde. Blir ihoptryckt vid minskning av fönster. Fixat.</p>
<p>Pkt 95: Narvostatistik per möte: Blir ihoptryckt vid minskning av fönster. Fixat.</p>
<p>Pkt 85: Rapport Institutioner - alla kolumner visas inte vid minskning av fönster. Fixat. </p>
<p>Pkt 72: Institutionsvyn - Kan editera institutionstyp som PS (ska inte gå). Fixat.
<p>Pkt 118: MinSida - Om man trycker F5 blir formuläret tomt. Fixat.</p>
<p>Pkt 97: Fixat GUI för gemensam sökvy rapporter när man ändrar storlek på fönster.</p>

<p><b>2020-11-17 16:40</b></p>
<p>Pkt 119: SysAdm kan inte koppla medlem till förening. Fixat.</p>
<p>Pkt 83: Rapport Utmärkelser - Icke utmärkelse blir samma som utmärkelse när man trycker på sök. Fixat.</p>
<p>Bildhantering: Gjort ändring för att test om det fungerar i testmiljön.</p>

<p><b>2020-11-17 14:30</b></p>
<p>90: Skrivit om backend för rapport: Åldersfördelning, ska kunna använda sig av ett liknande GUI som liknande rapporter. </p>
<p>91: Skrivit om backend för rapport: Åldersfördelning, borde inte längre ge fel. </p>
<p>101, 125: Fixat bugg som skapade felmeddelande när man avslutade medlemskap.</p>
<p>Fixat backend för rapport: Närvaro på institutionsnivå per månad.</p>
<p>Fixat backend för rapport: Närvaro på institutionsnivå.</p>
<p>Fixat backend för rapport: Närvaro per institution inom institutionens distrikt.</p>

<p><b>2020-11-16 18:45</b></p>
<p>Pkt 109: Fel rubrik för datum när man ska lägga till medlem till läger.</p>
<p>Pkt 71: Rapport - Möten: Sökformuläret ska vara expanderat som default.</p>
<p>Pkt 98: Rapport - Närvaro på institutitionsnivå. Får inget resultat. Fixat.</p>


<p><b>2020-11-10</b></p>
<p>Pkt 73: Institutionsvyn - Inaktivera länkar till föräldrainstitutioner i ändra-läget. Fixat.</p>
<p>Pkt 106: Kan inte hantera foton. Finns ny komponent för att ladda upp och hantera foton.</p>
<p>Pkt 69: Rapport möten kan flyttas till Sök Möten istället. Fixat. Den institution som aktuell roll har kopplad till sig blir default-val.</p>
<p>Pkt 70: Rapport möten (numera Sök Möten) ska vara utfällt från början. Fixat.</p>


<p><b>2020-11-09</b></p>
<p>Pkt.88-89: Rapport: Födelsedagslista. Fixat datum + sortering.</p>
<p>Rapport: Närvaro på institutionsnivå. Första version.</p>

<p><b>2020-11-09 11:10</b></p>
<p>Skapa ny institution: tagit bort validering så att det går att spara</p>

<p><b>2020-11-09 08:20</b></p>
<p>Skapa ny institution: Ska fungera bättre.</p>
<p>Navbar: Plockat bort ikon för att gå till roll-institution när userpermissionlevel = SY.</p>
<p>Fixat Wild characters (s.k "Jokertecken"), kan fortfarande finnas ställen där det inte fungerar, rapportera gärna dessa.</p>

<p><b>TESTPERIOD 2 (PS o PF) BÖRJAR</b></p>
<p><b>2020-11-08 18:20</b></p>
<p>Mobilläge: Har fixat några saker så att det ska fungera ok i mobilläge (efter diverse ändringar i applikationen).</p>
<p>Skapa ny institution: Har gjort ett par saker, bl a lagt till att man får välja vilken föräldrainstitution (Tillhör). Behöver dock synka med backend innan det fungerar.</p>
<p>Fixat bugg för "Skapa Institution"</p>

<p><b>2020-11-07 21:20</b></p>
<p>Navbar: Lagt till länk till den institution som är kopplad till aktuell roll.</p>
<p>Navbar: Bytt text på mina sidor samt ändrat tooltip-text när man hovrar över inloggad användare.</p>
<p>Startsida: Justerat några textrader enligt önskemål från Jan.</p>
<p>Institutionsvyn: Gjort ett försök att få till Medlemskapsmenyn för olika roller så att det ska stämma bättre.</p>
<p>Institutionsvyn/Medlemskapsmeny: PF kan lägga till medlemmar till sitt läger.</p>
<p>Knappar: Har satt en minsta bredd på knapparna till 100px. För de knappar som innehåller mer text blir knappen något bredare.</p>
<p>Rapporter: Ensat rapporthuvudena så att de ska vara mer homogena. Lagt till rapportrubrik.</p>

<p><b>2020-11-05 21:40</b></p>
<p>Skapa institution: Fixat så att knapparna för Spara, Ändra, Avbryt är aktiverade om användaren har behörighet.</p>
<p>Mina Sidor: När man redigerar en persons uppgifter döljs alla andra knappar/menyval.</p>
<p>Institutionsvyn: När man redigerar en institutions uppgifter döljs alla andra knappar/menyval</p>
<p>Skapa ny medlem: Sverige blir förvalt i Hemadress så att man inte behöver välja det.</p>
<p>Sök person: Ska gå att kombinera för- och efternamnssökning.</p>
<p>Personvyn: PS kan registrer ny medlem i Orden. (Osäker på vilken behörighet det är för Lägg till medlemskap så det ligger kvar.)</p>
<p>Skapa ny medlem: Lagt till datepicker för födelsedatum.</p>
<p>Skapa ny medlem: När SY-användare skapar ny medlem ska denne välja institution. Lagt till sökbar listbox.</p>
<p>Skapa ny medlem: Lagt till datepicker för invigningsdatum</p>
<p>Mötesvyn (addera gäster): Tagit bort logg-meddelandet som dök upp tidigare (alertbox).</p>
<p>Sök person: Lagt in datepicker för datumfälten.</p>
<p>Institution: Endast SY-användare kan redigera basuppgifter för institution.</p>

<p><b>2020-11-04 20:15</b></p>
<p><b>Rapporter</b></p>
<p>Födelsedagslista: Lagt till hyperlänk på medlemsid.</p>
<p>Födelsedagslista: Lagt till datum pipe på födelsedatum samt högtidsdag för att se om det fungerar bättre för Jan.</p>
<p>Övriga rapporter: Diverse GUI-fixar.</p>
<p>Hjälp: Lagt till länk till pdf-manual i sidopanelen.</p>

<p><b>2020-11-03 08:50</b></p>
<p>Rapport: Analys medlemsflöde.</p>

<p><b>2020-11-01 12:20</b></p>
<p>Fixat så att medlem skickas med till lägg till Uppdrag / Utmärkelser från Mina Sidor.</p>

<p><b>2020-10-31 12:00</b></p>
<p>Fixat så att det går att stänga maximerad dialog som används för att välja institutioner.</p>

<p><b>2020-10-31 11:00</b></p>
<p>Fixat Lägg till-knapp för Uppdrag och Utmärkelser på Mina Sidor.</p>
<p>Grupperat om rapporterna enligt Jans önskan.</p>

<p><b>2020-10-30 14:45</b></p>
<p><b>Fixat en del som har med PS-rollen att göra</b></p>
<p>Flyttat registrering av ny medlem i Orden när PS lägger till ny medlem till sin institution.</p>
<p>Lagt till vilken loge den nya medlemmen kommer tillhöra när PS registrerar ny medlem i systemet.</p>
<p>Bytt ut länkar till Uppdrag / Utmärkelser / Lilla Matrikeln till</p>
<p>Lagt till kontroller för att styra vad PS ska kunna göra och inte göra.</p>
<p>Gjort det möjligt för PS att ändra information om sin egen institution i institutionsvyn.</p>

<p><b>Sortering av uppdragslista</b></p>
<p>Nu ska uppdragen sorteras lite bättre. Samma fix är på gång för utmärkelser.</p>
<p>
  <b>2020-10-27 11:00</b>
</p>
<p><b>Åtgärdade saker enligt mail från Jan 2020-10-23:</b></p>
<p>Mina Sidor: Lägg land underst i adressrutorna</p>
<p>Matrikelkort: Lägg till ämbete, t ex Ledamot i Matrikelutskottet</p>
<p>Matrikelkort: Medlemsavgiftens procentsats bör hamna i egen kolumn</p>
<p>Sök person: Sök endast bland aktiva ska tas bort</p>
<p>Sök person: Sök med wildchar, t ex Lund%ist</p>
<p>Sök institution: Möten - lägg till Rubrik och Notering</p>
<p>Lilla Matrikeln: Lite formateringsfixar</p>
<p>Lilla Matrikeln: Lägg till funktionalitet för att skapa pdf.</p>
<p>Lilla Matrikeln: Fixat sorteringsordningen.</p>
<p>Tillägg av Övriga Förnamn i medlemsformuläret.</p>


<p>
  <b>2020-10-23 16:00</b>
</p>
<p>Wildcard characters, påpeka gärna vilka ställen det behövs, finns för tillfället bara i sök och rapporter för medlemmar och institutioner.</p>

<p>
  <b>2020-10-20 15:30</b>
</p>
<p><b>TESTDOKUMENTET (Google sheet)</b></p>
<p>55-56: Fel vid sökning på möten i institutionsvyn</p>
<p>32 + 37: Listan med roller ska stämma bättre överens med de uppdrag/ämbeten användaren har.</p>
<p>60 + 61: Problem med sök möte fixade.</p>

<p>
  <b>2020-10-20 09:20</b>
</p>

<p style="font-weight:bold;text-decoration: underline;"><b>PUNKTER FRÅN TESTDOKUMENTET (Google sheet):</b></p>
<p>62: Komma ihåg lösenord. Säkerhetsinställning i webbläsaren.</p>
<p>48: Vänd på funktionaliteten för VISA ALLT --> döp om till Nuvarande</p>
<p>47: Tillägg av tidsstämpel på Matrikelkort</p>
<p>26 + 46: Knapp för Matrikelkort saknas på Mina Sidor.</p>
<p>27: Kan justera fadder - administrativ uppgift</p>
<p>54: Står Ingen träff innan sökning gjorts Sök person vy</p>
<p>33: För många institutionstyper i dropdown för Sök person</p>
<p>35: Kan inte se länken till institutionens hemsida. Url:erna är lite konstiga i db. Url:en kan man se om man hovrar.</p>
<p>30: Får ingenting när jag klickar på Lilla Matrikeln. Lilla matrikeln är fixad.</p>
<p>49: Sök i institution är nu sorterat via nummer från grunden. </p>
<p>41: Filtrerar institutionslistan så att inte AV1, AVGBREV1, SOFT m m kommer med.</p>

<p></p>
<b>RAPPORTER</b>
<p>- Medlemmar</p>
<p>- Institutioner</p>
<p>- Utmärkelser</p>
<p>- Ämbeten</p>
<p>- Möten</p>
<p>- SOFT-prenumeranter (Excel)</p>
<p>- Närvaro per möte</p>
<p>- Institutioner per distrikt</p>
<p>- Nya institutioner per år</p>
<p>- Födelsedagslista</p>
<p>- Institutioner per distrikt</p>
<p>- Åldersfördelning</p>
<p>- Debiteringslängd</p>
<p>- Nya institutioner per år</p>
<p></p>
<p>Fixat medlemsrapport, kan nu söka på distrikt. </p>

<p></p>
<b>HJÄLPFUNKTION</b>
<p>Förberett struktur för att hantera hjälpfunktionalitet i utfällbar sidomeny.</p>
<p>Även förberett för att hantera hjälpinnehåll utifrån behörigheter.</p>
<p></p>
<p><b>WILDCARD-SÖKNINGAR</b></p>
<p>Översyn har gjorts för att se hur man skulle kunna hantera wildcard-sökningar i applikationen.</p>
